import { useQueryClient } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { CompanyComment } from "@/types";

/**
 * This hook is used to remove a company comment in the company comments query
 * without refetching the entire query.
 */
export const useRemoveCompanyComment = () => {
  const currentCompanyId = useCurrentCompanyId();
  const queryClient = useQueryClient();

  return ({ companyCommentId }: { companyCommentId: number }) => {
    queryClient.setQueryData(
      ["company-comments", currentCompanyId],
      (cachedData: CompanyComment[]) => {
        return cachedData.filter(
          (cachedCompanyComment: CompanyComment) =>
            cachedCompanyComment.id !== companyCommentId,
        );
      },
    );
  };
};
